<!-- This example requires Tailwind CSS v2.0+ -->
<div class="relative bg-blue-600 text-white shadow-xl">
  <div class="absolute inset-0 shadow z-30 pointer-events-none" aria-hidden="true"></div>
  <div class="relative z-20">
    <div class="
        max-w-7xl
        mx-auto
        flex
        justify-between
        items-center
        px-4
        py-5
        sm:px-6 sm:py-4
        lg:px-8
        md:justify-start
        space-x-4
        md:space-x-10
      ">
      <div>
        <a routerLink="/" class="flex">
          <span class="font-bold md:text-xl" [routerLink]="['/']">Maritime Photographie</span>
        </a>
      </div>
      <fw-search class="md:hidden flex-grow"></fw-search>
      <div class="-mr-2 -my-2 md:hidden">
        <button (click)="onMobileMenuToggle()" type="button" class="
            rounded-md
            p-2
            inline-flex
            items-center
            justify-center
            text-white
            hover:text-gray-200
            focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-400
          " aria-expanded="false">
          <span class="sr-only">Open menu</span>
          <!-- Heroicon name: outline/menu -->
          <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
            aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
      <div class="hidden md:flex-1 md:flex md:items-center md:justify-between" (clickOutside)="catMenuOpened = false">
        <nav class="flex space-x-10 items-center flex-grow">
          <a [routerLink]="['/about']" class="
              hidden
              lg:block
              text-base
              font-medium
              text-white
              hover:text-gray-200
            ">
            Der Fotograf
          </a>

          <button type="button" (click)="onCatMenuToggle()" class="
              text-white
              group
              rounded-md
              inline-flex
              items-center
              text-base
              font-medium
              hover:text-gray-200
              focus:outline-none
              focus:ring-2
              focus:ring-offset-2
              focus:ring-blue-400
            " aria-expanded="false">
            <span>Fotokategorien</span>
            <!--
              Heroicon name: solid/chevron-down

              Item active: "text-gray-600", Item inactive: "text-gray-400"
            -->
            <svg class="text-white ml-2 h-5 w-5 group-hover:text-gray-200" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd" />
            </svg>
          </button>
          <fw-search class="hidden md:block flex-grow"></fw-search>

          <!--
            'Fotogalerien' flyout menu, show/hide based on flyout menu state.

            Entering: "transition ease-out duration-200"
              From: "opacity-0 translate-y-1"
              To: "opacity-100 translate-y-0"
            Leaving: "transition ease-in duration-150"
              From: "opacity-100 translate-y-0"
              To: "opacity-0 translate-y-1"
          -->
          <div *ngIf="catMenuOpened" class="absolute top-16 z-10 -ml-4 mt-3 transform lg:max-w-3xl">
            <div class="
                rounded-lg
                shadow-lg
                ring-1 ring-black ring-opacity-5
                overflow-hidden
              ">
              <div class="
                  relative
                  flex flex-col
                  gap-6
                  bg-white
                  py-6
                  sm:gap-8 sm:p-8
                ">
                <!-- Categories -->
                <a (click)="onCatMenuToggle()" *ngFor="let cat of cats" [routerLink]="['/cat', cat?.id]"
                  class="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50">
                  <div class="ml-4">
                    <p class="text-base font-medium text-gray-900">
                      {{ cat.title }}
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>

  <!--
    Mobile menu, show/hide based on mobile menu state.

    Entering: "duration-200 ease-out"
      From: "opacity-0 scale-95"
      To: "opacity-100 scale-100"
    Leaving: "duration-100 ease-in"
      From: "opacity-100 scale-100"
      To: "opacity-0 scale-95"
  -->
  <div *ngIf="mobileMenuOpened" class="
      absolute
      z-30
      top-0
      inset-x-0
      p-2
      transition
      transform
      origin-top-right
      md:hidden
    ">
    <div class="
        rounded-lg
        shadow-lg
        ring-1 ring-black ring-opacity-5
        bg-white
        divide-y-2 divide-gray-50
      ">
      <div class="pt-5 pb-6 px-5 sm:pb-8">
        <div class="flex items-center justify-between">
          <div>
            <a (click)="onMobileMenuToggle()" class="font-bold text-xl text-gray-700" [routerLink]="['/']">Maritime
              Photographie</a>
          </div>
          <div class="-mr-2">
            <button (click)="onMobileMenuToggle()" type="button" class="
                bg-white
                rounded-md
                p-2
                inline-flex
                items-center
                justify-center
                text-gray-400
                hover:text-gray-500 hover:bg-gray-100
                focus:outline-none
                focus:ring-2
                focus:ring-inset
                focus:ring-blue-400
              ">
              <span class="sr-only">Close menu</span>
              <!-- Heroicon name: outline/x -->
              <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
        <div class="mt-12 sm:mt-16">
          <nav>
            <div class="flex flex-col space-y-4">
              <a (click)="onMobileMenuToggle()" [routerLink]="['/']"
                class="-m-3 py-4 flex items-center rounded-lg hover:bg-gray-50">
                <div class="ml-4 text-base font-medium text-gray-900">
                  Startseite
                </div>
              </a>

              <a (click)="onMobileMenuToggle()" [routerLink]="['/about']"
                class="-m-3 py-4 flex items-center rounded-lg hover:bg-gray-50">
                <div class="ml-4 text-base font-medium text-gray-900">
                  Über den Fotografen
                </div>
              </a>
            </div>
          </nav>
        </div>
      </div>
      <div class="px-5 mt-8 text-base">
        <p (click)="onMobileMenuToggle()" [routerLink]="['/cat', 1]" class="font-bold text-xl text-gray-700">
          Fotokategorien
        </p>
      </div>
      <div class="py-6 px-5">
        <div class="grid grid-cols-2 gap-4">
          <a (click)="onMobileMenuToggle()" *ngFor="let cat of cats" [routerLink]="['/cat', cat?.id]" class="
              rounded-md
              text-base
              font-medium
              text-gray-900
              hover:text-gray-700
            ">
            {{ cat.title }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
